
import {ContinueScreen} from "../../core/screen/ContinueScreen";
import {gsap, TimelineLite} from "gsap";
import {DevilsCrossRoadLayers, Layers} from "./DevilsCrossRoadLayers";
import {DevilsCrossRoad} from "../DevilsCrossRoad";

export class WinCapScreen extends ContinueScreen {
    private _mainTl: TimelineLite | null;

    constructor() {
        super(DevilsCrossRoadLayers.getLayer(Layers.SCREENS)!);
    }

    public show(onContinueCallBack: () => void) {
        this.visible = true;
        this.onOrientationChanged();

        const tl = gsap.timeline();
        tl.add(()=>{

            DevilsCrossRoad.totalWinCountUp.remove();
            DevilsCrossRoad.bigWinCountUp.remove();
        });
        tl.add(DevilsCrossRoad.transitionScreenView.maxCap.showWinCap());
        tl.add(()=>{
            super.show(onContinueCallBack);
        },"<7");
        this._mainTl = tl;
    }

    protected close(): TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            if (this._mainTl) {
                if (this._mainTl.isActive()) {
                    this._mainTl.progress(1);
                }
                this._mainTl.kill();
                this._mainTl = null;
            }
        });
        tl.add(DevilsCrossRoad.transitionScreenView.maxCap.hideWinCap());
        tl.add(super.close());
        return tl;
    }

    public onOrientationChanged() {
        if (!this.visible) {
            return;
        }
        super.onOrientationChanged();
    }
}